import { observer } from 'mobx-react';

import { Wizard } from '../../../components/Wizard/Wizard';
import { useStores } from '../../../stores/useStores';
import { ChooseCountryWizardStepRedesign } from '../redesign-components/ChooseCountryRedesign/ChooseCountryWizardStepRedesign';
import { authWizardWrapperStyle } from '../wizards/constants';
import styles from '../wizards/RedesignWizard.module.scss';

const ChooseCountryPortalStep = observer(function ChooseCountryPortalStep() {
  const { portalStore } = useStores();

  return <ChooseCountryWizardStepRedesign isCurrent nextStep={() => portalStore.closePortal()} />;
});

const steps = [ChooseCountryPortalStep];

/**
 * The redesigned country select opened on its own in the portal. It goes through a single-step Wizard so it gets
 * the same sizing as inside PostSignUpWizard.
 */
export const ChooseCountryRedesignPortal = function ChooseCountryRedesignPortal() {
  return (
    <Wizard
      classNameSteps={styles.redesignFlowSteps}
      classNameStepWrapper={styles.redesignFlowStepWrapper}
      steps={steps}
      wizardFlowParams={{ isRedesignSteps: true }}
      wrapperStyle={authWizardWrapperStyle}
    />
  );
};
